// Keep VectorSource's loaded/in-flight BBOX cache across visibility changes.
// OpenLayers handles concurrent requests and deduplicates covered extents.
export function loadLayerSourceForCurrentWindow(layer, extent, resolution, projection, view) {
  if (!extent || !Number.isFinite(resolution) || !projection) return;
  if (view?.getAnimating?.() || view?.getInteracting?.()) return;

  const source = layer.get?.('wfsSource') || layer.getSource?.();
  source?.loadFeatures?.(extent, resolution, projection);
}
